import apiClient from "../utils/apiClient";
// 注册账号
const Register = async (params) => {
    return apiClient.post("/api/auth/RegisterWithKeys", params);
};
// 登录
const Login = async (params) => {
    return apiClient.post("/api/auth/login", params);
};
// 修改密码
const Password = async (params) => {
    return apiClient.post("/api/auth/ChangePassword", params);
};
// 上传文件
const UploadFile = async (file) => {
    var _a;
    console.log("Uploading file:", file);
    const token = (_a = JSON.parse(localStorage.getItem("userInfo") || "{}").token) !== null && _a !== void 0 ? _a : "";
    const baseURL = (typeof window !== "undefined" && window.BASE_URL) ||
        (typeof process !== "undefined" && process.env.VITE_BASE_URL) ||
        (location.hostname === "localhost" ||
            (location.hostname === "192.168.0.125" && location.port === "3015")
            ? "http://192.168.0.15:8000"
            : "/");
    const url = baseURL.replace(/\/$/, "") + "/admin/upload";
    const formData = new FormData();
    formData.append("file", file);
    const response = await fetch(url, {
        method: "POST",
        body: formData,
        headers: { "Admin-Authorization": `Bearer ${token}` },
    });
    return response.json();
};
// 获取账户信息
const GetUserInfo = async () => {
    return apiClient.get("/api/auth/AccountInfo");
};
// 获取用户列表
const GetUserList = async (data) => {
    return apiClient.get("/admin/users", data);
};
// 添加用户
const AddUser = async (data) => {
    return apiClient.post("/admin/users", data);
};
// 删除用户
const DelUser = async (id) => {
    return apiClient.delete(`/admin/users/${id}`);
};
// 获取统计数据
const GetStats = async () => {
    return apiClient.get("/admin/stats");
};
// 获取统计报名数据
const GetStatsEntry = async () => {
    return apiClient.get("/admin/stats/latest_registrations");
};
const userAuth = {
    Login,
    Register,
    Password,
    UploadFile,
    GetUserInfo,
    GetUserList,
    AddUser,
    DelUser,
    GetStats,
    GetStatsEntry,
};
export default userAuth;
